// @flow
import type { TridentCampaignDetails } from 'types/trident-campaigns';
import React, { Component } from 'react';
import _ from 'lodash';
import { RandomizerWidget, TimeWidget, ScheduleWidget, ActionWidget, ConditionWidget, ScenarioWidget, CounterWidget, CountConditionWidget, DelayWidget, ExperimentWidget, EnumerationWidget } from 'components/form/trident-campaigns';
import { nodeTypes } from 'data/trident-types';
import 'components/form/trident-campaigns/FlowDesign.scss';

type Props = {
  model: TridentCampaignDetails,
  canActivate: boolean,
  currentNodeKey: string,
  onModelChange: (_?: Object) => void,
  handleAddNode: Function,
  handleNodePreview: Function,
  clickedNode: string,
};

export default class TridentTreatmentBuilder extends Component {
  props: Props;

  preOrderTraversalFromCurrentNodeToItsChildren = function (currentNodeKey: string, flowCompleted: any) {
    if (_.get(this.props.model.nodes[currentNodeKey], 'children', []).length <= 0 && _.get(this.props.model.nodes[currentNodeKey], 'type', '') !== 'actions') {
      return false;
    }
    for (let i = 0; i < _.get(this.props.model.nodes[currentNodeKey], 'children', []).length; i += 1) {
      const childArray = _.get(this.props.model.nodes[currentNodeKey], 'children', []);
      flowCompleted = flowCompleted && this.preOrderTraversalFromCurrentNodeToItsChildren(childArray[i], flowCompleted);
    }
    return flowCompleted;
  };
  render() {
    const { model, canActivate, currentNodeKey, appConfig } = this.props;
    const flowCompleted = this.preOrderTraversalFromCurrentNodeToItsChildren(currentNodeKey, true);

    let classNameForFirstNodeBranch = 'chainScenarioBranch';
    if (_.get(model.nodes[currentNodeKey], 'data.scenarios', []).length <= 1) {
      if (flowCompleted || _.get(model.nodes[currentNodeKey], 'type', '') === 'time') {
        classNameForFirstNodeBranch = 'scenarioBranch';
      } else {
        classNameForFirstNodeBranch = 'scenarioFlowNotCompBranch';
      }
    }
    return (
      <div id="wrapper">
        <span className={_.get(model.nodes[currentNodeKey], 'data.scenarios', []).length > 1 ? 'wrapStartingChainScenarioNodeDesign' : 'wrapStartingNodeDesign'}>
          {_.get(model.nodes[currentNodeKey], 'type', '') === nodeTypes.scenarios &&
            <ScenarioWidget
              onModelChange={this.props.onModelChange}
              model={model}
              currentNodeKey={currentNodeKey}
              canActivate={canActivate}
              handleAddNode={this.props.handleAddNode}
              handleNodePreview={this.props.handleNodePreview}
              clickedNode={this.props.clickedNode}
              appConfig={appConfig}
            />
          }
          {_.get(model.nodes[currentNodeKey], 'type', '') === nodeTypes.time &&
            <TimeWidget
              onModelChange={this.props.onModelChange}
              model={model}
              currentNodeKey={currentNodeKey}
              canActivate={canActivate}
              handleAddNode={this.props.handleAddNode}
              handleNodePreview={this.props.handleNodePreview}
              clickedNode={this.props.clickedNode}
            />
          }
          {
            _.get(model.nodes[currentNodeKey], 'type') === nodeTypes.schedule &&
            <ScheduleWidget
              onModelChange={this.props.onModelChange}
              model={model}
              currentNodeKey={currentNodeKey}
              canActivate={canActivate}
              handleAddNode={this.props.handleAddNode}
              handleNodePreview={this.props.handleNodePreview}
              clickedNode={this.props.clickedNode}
            />
          }
        </span>
        {_.get(model.nodes[currentNodeKey], 'children', []).length > 0 &&
          <div className={classNameForFirstNodeBranch}>
            {_.get(model.nodes[currentNodeKey], 'children', []).map((childKey, index) => {
              if (_.get(model.nodes[childKey], 'type', '') === nodeTypes.count) {
                return (
                  <CounterWidget
                    key={`${index}${_.get(model.nodes[childKey], 'type')}`}
                    onModelChange={this.props.onModelChange}
                    model={model}
                    currentNodeKey={childKey}
                    canActivate={canActivate}
                    handleAddNode={this.props.handleAddNode}
                    handleNodePreview={this.props.handleNodePreview}
                    parentKeyList={[currentNodeKey]}
                    clickedNode={this.props.clickedNode}
                  />
                );
              }
              if (_.get(model.nodes[childKey], 'type', '') === nodeTypes.countCondition) {
                return (
                  <CountConditionWidget
                    key={`${index}${_.get(model.nodes[childKey], 'type')}`}
                    onModelChange={this.props.onModelChange}
                    model={model}
                    currentNodeKey={childKey}
                    canActivate={canActivate}
                    handleAddNode={this.props.handleAddNode}
                    handleNodePreview={this.props.handleNodePreview}
                    parentKeyList={[currentNodeKey]}
                    clickedNode={this.props.clickedNode}
                  />
                );
              }
              if (_.get(model.nodes[childKey], 'type', '') === nodeTypes.condition) {
                return (
                  <ConditionWidget
                    key={`${index}${_.get(model.nodes[childKey], 'type')}`}
                    onModelChange={this.props.onModelChange}
                    model={model}
                    currentNodeKey={childKey}
                    canActivate={canActivate}
                    handleAddNode={this.props.handleAddNode}
                    handleNodePreview={this.props.handleNodePreview}
                    parentKeyList={[currentNodeKey]}
                    clickedNode={this.props.clickedNode}
                  />
                );
              }
              if (_.get(model.nodes[childKey], 'type', '') === nodeTypes.delay) {
                return (
                  <DelayWidget
                    key={`${index}${_.get(model.nodes[childKey], 'type')}`}
                    onModelChange={this.props.onModelChange}
                    model={model}
                    currentNodeKey={childKey}
                    canActivate={canActivate}
                    handleAddNode={this.props.handleAddNode}
                    handleNodePreview={this.props.handleNodePreview}
                    parentKeyList={[currentNodeKey]}
                    clickedNode={this.props.clickedNode}
                  />
                );
              }
              if (_.get(model.nodes[childKey], 'type', '') === nodeTypes.experiment) {
                return (
                  <ExperimentWidget
                    key={`${index}${_.get(model.nodes[childKey], 'type')}`}
                    onModelChange={this.props.onModelChange}
                    model={model}
                    currentNodeKey={childKey}
                    canActivate={canActivate}
                    handleAddNode={this.props.handleAddNode}
                    handleNodePreview={this.props.handleNodePreview}
                    parentKeyList={[currentNodeKey]}
                    clickedNode={this.props.clickedNode}
                  />
                );
              }
              if (_.get(model.nodes[childKey], 'type', '') === nodeTypes.enumeration) {
                return (
                  <EnumerationWidget
                    model={model}
                    canActivate={canActivate}
                    currentNodeKey={childKey}
                    parentKeyList={[currentNodeKey]}
                    onModelChange={this.props.onModelChange}
                    handleAddNode={this.props.handleAddNode}
                    handleNodePreview={this.props.handleNodePreview}
                    clickedNode={this.props.clickedNode}
                  />
                );
              }
              if (_.get(model.nodes[childKey], 'type', '') === nodeTypes.randomizer) {
                return (
                  <RandomizerWidget
                    model={model}
                    canActivate={canActivate}
                    currentNodeKey={childKey}
                    parentKeyList={[currentNodeKey]}
                    onModelChange={this.props.onModelChange}
                    handleAddNode={this.props.handleAddNode}
                    handleNodePreview={this.props.handleNodePreview}
                    clickedNode={this.props.clickedNode}
                  />
                );
              }
              return (
                <ActionWidget
                  key={`${index}${_.get(model.nodes[childKey], 'type')}`}
                  onModelChange={this.props.onModelChange}
                  model={model}
                  currentNodeKey={childKey}
                  canActivate={canActivate}
                  handleNodePreview={this.props.handleNodePreview}
                  parentKeyList={[currentNodeKey]}
                  clickedNode={this.props.clickedNode}
                />
              );
            })}
          </div>
        }
      </div>
    );
  }
}
